import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import {
  getSubordinateAgentData,
  getSubordinateBasicInfo,
  getSubordinateMemberData,
  getSubordinateUserData,
  getSubordinateUserDetailData,
} from "../service";

export const useGetSubordinateBasicInfo = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.SUBORDINATE_BASIC_INFO, ..._arrParams],
    ({ pageParam = 1 }) =>
      getSubordinateBasicInfo({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

export const useGetSubordinateUserData = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.SUBORDINATE_USER_DATA, ..._arrParams],
    ({ pageParam = 1 }) =>
      getSubordinateUserData({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

export const useGetSubordinateUserDetailData = ({ params, childId, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.SUBORDINATE_USER_DETAIL_DATA, childId, ..._arrParams],
    () => getSubordinateUserDetailData({ params, childId }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

//agentData
export const useGetSubordinateAgentData = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.SUBORDINATE_USER_DATA, ..._arrParams],
    ({ pageParam = 1 }) =>
      getSubordinateAgentData({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};
//memberData
export const useGetSubordinateMemberData = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.SUBORDINATE_USER_DATA, ..._arrParams],
    ({ pageParam = 1 }) =>
      getSubordinateMemberData({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};
